
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/[id]/[slug]",
      function () {
        return require("private-next-pages/news/[id]/[slug].tsx");
      }
    ]);
  